import template from 'text!./templates/Default.html';

var definition = {
    restrict: 'E',
    scope: {
        property: '&propertyInfo',
        hideRequired: '<'
    },
    template: template
};

var directive = [function () {
    return definition;
}];
directive.definition = definition;

export default directive;


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/schedules/propertyHeaders/table/Default.js
// module id = 105
// module chunks = 0